const GreffierMesureMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexWrap: "wrap",
  mt: "6",
  overFlow: "hidden",
  p: "3",
  position: "relative",
  width: "100%",
};

const GreffierMesureMainMandataireStyle = {
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  pt: 5,
  px: 4,
};

const GreffierMesureSideMandataireStyle = {
  bg: "white",
  borderRadius: "6px",
  flexBasis: 380,
  flexGrow: 1,
  minHeight: "320px",
};

const GreffierMesureTitleMandataireStyle = {
  color: "textSecondary",
  fontFamily: "heading",
  fontSize: 0,
  mb: "4px",
};

const GreffierMesureContentMandataireStyle = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: 4,
};

const GreffierTribunal = {
  color: "text",
  fontFamily: "body",
  fontSize: 1,
  fontWeight: "600",
  mb: "5px",
};

const boxStyle = {
  flexGrow: 1,
};

const topTextStyle = {
  color: "black",
  fontWeight: "600",
  mb: "5px",
};

const GreffierMesureAntennesStyle = {
  bg: "white",
  borderRadius: "6px",
  flexBasis: 0,
  flexGrow: 99999,
  minWidth: 320,
  mt: "6",
  pt: 5,
  px: 4,
};

export {
  GreffierMesureMandataireStyle,
  GreffierMesureMainMandataireStyle,
  GreffierMesureSideMandataireStyle,
  GreffierMesureTitleMandataireStyle,
  GreffierMesureContentMandataireStyle,
  topTextStyle,
  boxStyle,
  GreffierMesureAntennesStyle,
  GreffierTribunal,
};
